import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (typeof url !== "string" || url.trim() === "") {
  throw new Error(
    "VITE_SUPABASE_URL is missing or empty. Set it in .env (see content/CONTEXT.md).",
  );
}

if (typeof anonKey !== "string" || anonKey.trim() === "") {
  throw new Error(
    "VITE_SUPABASE_ANON_KEY is missing or empty. Set it in .env (see content/CONTEXT.md).",
  );
}

export const supabase = createClient(url.trim(), anonKey.trim());
